import React from "react";
import "./AcornSemiPlannedPublishing.css";
import ComparisonTable from "../../../Shared/ComparisonTable/ComparisonTable";

const benefitsData = [
  { title: "비용절감", subtitle: "자비 출판 대비 50% 비용 절약" },
  { title: "전문성", subtitle: "출판사의 기획력과 마케팅 노하우 활용" },
  { title: "맞춤협업", subtitle: "저자의 전문성과 출판사의 노하우 결합" },
  { title: "품질향상", subtitle: "출판사의 전문 편집 및 디자인" },
];

const recommendedForData = [
  "어느 정도 완성도 있는 원고를 보유한 저작자",
  "출판사의 전문성을 원하지만 비용 부담을 줄이고 싶은 저작자",
  "시장성 있는 콘텐츠를 가진 저작자",
  "출판사와 협업을 통해 품질을 높이고 싶은 저작자",
];

const AcornSemiPlannedPublishing = () => {
  return (
    <section className="acorn-semi-planned-section">
      <div className="intro-section">
        <h1 className="section-title">반기획 출판이란 무엇인가요?</h1>
        <p className="section-description">
          반기획 출판은 출판사와 저작자가 비용과 수익을 50:50으로 분담하는 출판
          방식입니다.
          <br />
          출판사가 전문적인 기획과 제작을 담당하고, 저작자는 원고와 일부 비용을
          제공합니다.
        </p>
      </div>

      <div className="benefits-section">
        <h1 className="section-title">
          에이콘 반기획 출판의 장점은 무엇인가요?
        </h1>
        <div className="benefits-grid-semi-planned">
          {benefitsData.map((benefit, index) => (
            <div key={index} className="benefit-card-semi-planned">
              <h3>{benefit.title}</h3>
              <p>{benefit.subtitle}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="recommended-for-section">
        <h1 className="section-title">반기획 출판, 이런 분들에게 추천합니다!</h1>
        <div className="recommended-for-grid-semi-planned">
          {recommendedForData.map((item, index) => (
            <div key={index} className="recommended-for-card-semi-planned">
              <p>{item}</p>
            </div>
          ))}
        </div>
      </div>

      <ComparisonTable highlightedColumn="semi" />
    </section>
  );
};

export default AcornSemiPlannedPublishing;
